document.addEventListener('DOMContentLoaded', () => {

const quiz = document.querySelector('[data-quiz]');
const modalContent = document.querySelector('.quiz-modal-content');

if (!quiz) return;

const panels = quiz.querySelectorAll('.quiz-step-panel');
const header = quiz.querySelector('.quiz-header');
const stepIndicator = quiz.querySelector('[data-step-indicator]');
const startBtn = quiz.querySelector('[data-start-quiz]');
const backBtn = quiz.querySelector('[data-quiz-back]');
const restartBtn = document.querySelector('[data-restart-quiz]');
const productsGrid = quiz.querySelector('.quiz-products-grid');
if(!productsGrid) return;

let currentStep = 0;
let answers = [];

const totalQuestions = quiz.querySelectorAll(
'.quiz-step-panel[data-step]:not([data-step="0"]):not([data-step="no-results"]):not([data-step="results"])'
).length;


function showStep(step){

panels.forEach(panel => panel.hidden = true);

const panel = quiz.querySelector(`[data-step="${step}"]`);

if(!panel) return;

panel.hidden = false;

modalContent.classList.toggle('is-intro', step === 0);
modalContent.classList.toggle('is-results', step === 'results');

// hide header on intro and results
header.hidden = (step === 0 || step === 'results');

if(step > 0 && step !== 'results'){
stepIndicator.textContent = `${step} of ${totalQuestions}`;
}
}


// ✅ (no popup delay)
showStep(0);


// start
startBtn.addEventListener('click', () => {

currentStep = 1;
showStep(currentStep);

});


// back
backBtn.addEventListener('click', () => {

currentStep = currentStep > 1 ? currentStep - 1 : 0;

showStep(currentStep);

});


// restart
if(restartBtn){
restartBtn.addEventListener('click', () => {

answers = [];
currentStep = 0;

showStep(currentStep);
   window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
});
}



// OPTION CLICK
quiz.addEventListener('click', e => {

const option = e.target.closest('.quiz-option');

if(!option) return;

const value = option.dataset.value;

answers[currentStep - 1] = value;

currentStep++;


// LAST STEP
if(currentStep > totalQuestions){

const wear = answers[0];
const mood = answers[1];
const smell = answers[2];

const key = `${wear}|${mood}|${smell}`.toLowerCase().replace(/\s+/g,'');


// PRODUCT MAPPING
const quizResults = {

"nightout|happy|woodburningfireplace":[
"DNVR136",
"DNVR663",
],

"nightout|happy|cutgrass":[
"DNVR618",
],

"nightout|happy|rosegarden":[
"DNVR870",
"DNVR643",
],

"nightout|happy|mulledwine":[
"DNVR973",
],

"nightout|happy|oceanair":[
"DNVR048",
"DNVR209",
"DNVR499",
],

"nightout|sensual|woodburningfireplace":[
"DNVR628",
"DNVR500",
],

"nightout|sensual|cutgrass":[
"DNVR636",
"DNVR124",
],

"nightout|sensual|rosegarden":[
"DNVR870",
],

"nightout|sensual|mulledwine":[
"DNVR099",
],

"nightout|sensual|oceanair":[
"DNVR639",
"DNVR105",
],

"nightout|confident|woodburningfireplace":[
"DNVR191",
"DNVR101",
],

"nightout|confident|cutgrass":[
"DNVR118",
],

"nightout|confident|rosegarden":[
"DNVR256",
],

"nightout|confident|mulledwine":[
"DNVR233",
],

"nightout|confident|oceanair":[
"DNVR211",
"DNVR128",
],

"nightout|classic|woodburningfireplace":[
"DNVR065",
"DNVR966",
],

"nightout|classic|cutgrass":[
"DNVR098",
],

"nightout|classic|rosegarden":[
"DNVR641",
],

"nightout|classic|mulledwine":[
"DNVR138",
],

"nightout|classic|oceanair":[
"DNVR501",
],


"specialoccasion|happy|woodburningfireplace":[
"DNVR870",
],

"specialoccasion|happy|cutgrass":[
"DNVR098",
],

"specialoccasion|happy|rosegarden":[
"DNVR205",
],

"specialoccasion|happy|mulledwine":[
"DNVR497",
],

"specialoccasion|happy|oceanair":[
"DNVR126",
],

"specialoccasion|sensual|woodburningfireplace":[
"DNVR136",
"DNVR663",
],

"specialoccasion|sensual|cutgrass":[
"DNVR665",
],

"specialoccasion|sensual|rosegarden":[
"DNVR203",
"DNVR110",
],

"specialoccasion|sensual|mulledwine":[
"DNVR437",
],

"specialoccasion|sensual|oceanair":[
"DNVR048",
],

"specialoccasion|confident|woodburningfireplace":[
"DNVR648",
],

"specialoccasion|confident|cutgrass":[
"DNVR647",
],

"specialoccasion|confident|rosegarden":[
"DNVR967",
"DNVR106",
],

"specialoccasion|confident|mulledwine":[
"DNVR973",
],

"specialoccasion|confident|oceanair":[
"DNVR335",
],

"specialoccasion|classic|woodburningfireplace":[
"DNVR969",
],

"specialoccasion|classic|cutgrass":[
"DNVR103",
"DNVR638",
],

"specialoccasion|classic|rosegarden":[
"DNVR968",
],

"specialoccasion|classic|mulledwine":[
"DNVR096",
],

"specialoccasion|classic|oceanair":[
"DNVR097",
],

"everyday|happy|woodburningfireplace":[
"DNVR870",
"DNVR643",
],

"everyday|happy|cutgrass":[
"DNVR618",
],

"everyday|happy|rosegarden":[
"DNVR205",
"DNVR112",
],

"everyday|happy|mulledwine":[
"DNVR125",
],

"everyday|happy|oceanair":[
"DNVR209",
"DNVR122",
],

"everyday|sensual|woodburningfireplace":[
"DNVR470",
],

"everyday|sensual|cutgrass":[
"DNVR098",
],

"everyday|sensual|rosegarden":[
"DNVR641",
],

"everyday|sensual|mulledwine":[
"DNVR099",
],

"everyday|sensual|oceanair":[
"DNVR126",
],

"everyday|confident|woodburningfireplace":[
"DNVR470",
],

"everyday|confident|cutgrass":[
"DNVR870",
"DNVR643",
],

"everyday|confident|rosegarden":[
"DNVR205",
"DNVR112",
],

"everyday|confident|mulledwine":[
"DNVR497",
],

"everyday|confident|oceanair":[
"DNVR211",
"DNVR128",
],

"everyday|classic|woodburningfireplace":[
"DNVR191",
"DNVR101",
],

"everyday|classic|cutgrass":[
"DNVR618",
],

"everyday|classic|rosegarden":[
"DNVR205",
"DNVR496",
],

"everyday|classic|mulledwine":[
"DNVR973",
],

"everyday|classic|oceanair":[
"DNVR639",
"DNVR634",
"DNVR209",
],


"office|happy|woodburningfireplace":[
"DNVR136",
"DNVR663",
],

"office|happy|cutgrass":[
"DNVR967",
"DNVR106",
],

"office|happy|rosegarden":[
"DNVR205",
"DNVR496",
],

"office|happy|mulledwine":[
"DNVR437",
],

"office|happy|oceanair":[
"DNVR048",
],

"office|sensual|woodburningfireplace":[
"DNVR628",
],

"office|sensual|cutgrass":[
"DNVR211",
"DNVR128",
],

"office|sensual|rosegarden":[
"DNVR065",
"DNVR966",
],

"office|sensual|mulledwine":[
"DNVR973",
],

"office|sensual|oceanair":[
"DNVR097",
],

"office|confident|woodburningfireplace":[
"DNVR969",
],

"office|confident|cutgrass":[
"DNVR618",
],

"office|confident|rosegarden":[
"DNVR870",
"DNVR643",
],

"office|confident|mulledwine":[
"DNVR973",
"DNVR215",
],

"office|confident|oceanair":[
"DNVR209",
"DNVR646",
],

"office|classic|woodburningfireplace":[
"DNVR636",
"DNVR124",
],

"office|classic|cutgrass":[
"DNVR618",
],

"office|classic|rosegarden":[
"DNVR870",
"DNVR643",
],

"office|classic|mulledwine":[
"DNVR099",
],

"office|classic|oceanair":[
"DNVR097",
],

};


const products = quizResults[key];

if(!products || products.length === 0){
  showStep('no-results');
  return;
}else{
  showStep('results');
}


// if(products.length === 1){

// const sku = products[0];

// const product = window.quizProducts.find(p => 
// p.sku && p.sku.toLowerCase() === sku.toLowerCase()
// );

// if(product){
// window.location.href = product.url;
// }

// }

let foundProduct = false;

// SHOW PRODUCTS
productsGrid.querySelectorAll('.quiz-product-item').forEach(item=>{
item.style.display='none';
});

products.forEach(handle=>{

const sku = handle;

const productData = window.quizProducts.find(p =>
p.sku && p.sku.toLowerCase() === sku.toLowerCase()
);

if(productData){
const product = productsGrid.querySelector(`[data-handle="${productData.handle}"]`);
if(product){
product.style.display='block';
 foundProduct = true; 
}
}

});

if(foundProduct){
  showStep('results');
}else{
  showStep('no-results');
}

return;

}

showStep(currentStep);

});

});